import React from 'react';
import './ColorScheme.css';

const colorScheme = ( props ) => {
	const styleInfo = [
		{
			styleDefs: [
				'background-color: ' + props.color1
			],
			selectors: [
				'.bg-color-1',
				'hr.color-1',
				'.bg-color-1 .FlipCard .Icon',
				'.side-1.flip-bg-color-1 .card-content',
				'.side-2.flip-bg-color-1 .card-content',
				'.side-1.flip-bg-color-1 .card-backdrop',
				'.side-2.flip-bg-color-1 .card-backdrop',
				'.bg-color-1 .FlipCard .card-backdrop:before'
			]
		},
		{
			styleDefs: [
				'background-color: ' + props.color2
			],
			selectors: [
				'.bg-color-2',
				'hr.color-2',
				'.bg-color-2 .FlipCard .Icon',
				'.side-1.flip-bg-color-2 .card-content',
				'.side-2.flip-bg-color-2 .card-content',
				'.side-1.flip-bg-color-2 .card-backdrop',
				'.side-2.flip-bg-color-2 .card-backdrop',
				'.bg-color-2 .FlipCard .card-backdrop:before'
			]
		},
		{
			styleDefs: [
				'background-image: linear-gradient( to right, ' + props.color1 + ',' + props.color2 + ')'
			],
			selectors: [
				'#Intro:after',
				'.SlideshowContainer .Slideshow .Slides .Slide:after',
				'.bg-gradient.horizontal',
				'hr.horizontal',
				'.SideNav a',
				'.bg-gradient.horizontal .FlipCard .Icon',
				'.side-1.flip-bg-gradient.horizontal .card-content',
				'.side-2.flip-bg-gradient.horizontal .card-content',
				'.side-1.flip-bg-gradient.horizontal .card-backdrop',
				'.side-2.flip-bg-gradient.horizontal .card-content',
				'.bg-gradient.horizontal .FlipCard .card-backdrop:before'
			]
		},
		{
			styleDefs: [
				'background-image: linear-gradient( to right, ' + props.color2 + ',' + props.color1 + ')'
			],
			selectors: [
				'.bg-gradient.horizontal.invert',
				'hr.horizontal.invert',
				'.bg-gradient.horizontal.invert .FlipCard .Icon',
				'.side-1.flip-bg-gradient.horizontal.invert .card-content',
				'.side-2.flip-bg-gradient.horizontal.invert .card-content',
				'.side-1.flip-bg-gradient.horizontal.invert .card-backdrop',
				'.side-2.flip-bg-gradient.horizontal.invert .card-backdrop',
				'.bg-gradient.horizontal.invert .FlipCard .card-backdrop:before'
			]
		},
		{
			styleDefs: [
				'background-image: linear-gradient( to bottom, ' + props.color1 + ',' + props.color2 + ')'
			],
			selectors: [
				'.bg-gradient.vertical',
				'hr.vertical',
				'.bg-gradient.vertical .FlipCard .Icon',
				'.side-1.flip-bg-gradient.vertical .card-content',
				'.side-2.flip-bg-gradient.vertical .card-content',
				'.side-1.flip-bg-gradient.vertical .card-backdrop',
				'.side-2.flip-bg-gradient.vertical .card-backdrop',
				'.bg-gradient.vertical .FlipCard .card-backdrop:before'
			]
		},
		{
			styleDefs: [
				'background-image: linear-gradient( to bottom, ' + props.color2 + ',' + props.color1 + ')'
			],
			selectors: [
				'.bg-gradient.vertical.invert',
				'hr.vertical.invert',
				'.bg-gradient.vertical.invert .FlipCard .Icon',
				'.side-1.flip-bg-gradient.vertical.invert .card-content',
				'.side-2.flip-bg-gradient.vertical.invert .card-content',
				'.side-1.flip-bg-gradient.vertical.invert .card-backdrop',
				'.side-2.flip-bg-gradient.vertical.invert .card-backdrop',
				'.bg-gradient.vertical.invert .FlipCard .card-backdrop:before'
			]
		},
		{
			styleDefs: [
				'color: ' + props.color1
			],
			selectors: [
				'a',
				'a:visited',
				'a:active',
				'a.active'
			]
		},
		{
			styleDefs: [
				'color: ' + props.color2
			],
			selectors: [
				'a:hover'
			]
		},
		{
			styleDefs: [
				'color: ' + props.color1 + ' !important'
			],
			selectors: [
				'.bg-color-1 .FlipCard .card-text',
				'.bg-color-1 .FlipCard .card-text p'
			]
		},
		{
			styleDefs: [
				'color: ' + props.color2 + ' !important'
			],
			selectors: [
				'.bg-color-2 .FlipCard .card-text',
				'.bg-color-2 .FlipCard .card-text p'
			]
		},
		{
			styleDefs: [
				'fill: ' + props.color1
			],
			selectors: [
				'a svg',
				'a:visited svg',
				'a:hover svg',
				'a:active svg',
				'a.active svg',
				'.side-2.flip-bg-color-1 .card-thumbnail svg',
				'.bg-color-1 div .CurvedBottomContainer .CurvedBottom path'
			]
		},
		{
			styleDefs: [
				'fill: ' + props.color2
			],
			selectors: [
				'a:hover svg',
				'.side-2.flip-bg-color-2 .card-thumbnail svg',
				'.bg-color-2 div .CurvedBottomContainer .CurvedBottom path'
			]
		}
	];
	
	if( props.textColor ) {
		styleInfo.push({
			styleDefs: [
				'color: ' + props.textColor
			],
			selectors: [
				'h1',
				'h2',
				'p',
				'ul',
				'li'
			]
		});
	}
	
	const styleTag = {
		__html: styleInfo.map( style => (
				style.selectors.join( ',' ) + '{' + style.styleDefs.join( ';' ) + '}'
			)).join( ' ' )
	};
	
	const gradientMask = (
		<svg aria-hidden="true" focusable="false" style={{ width: '0', height: '0', position: 'absolute' }}>
			<linearGradient id="gradient-vertical" x2="0" y2="1">
				<stop offset="0%" stopColor={ props.color1 } />
				<stop offset="100%" stopColor={ props.color2 } />
			</linearGradient>
			<linearGradient id="gradient-vertical-invert" x2="0" y2="1">
				<stop offset="0%" stopColor={ props.color2 } />
				<stop offset="100%" stopColor={ props.color1 } />
			</linearGradient>
			<linearGradient id="gradient-horizontal">
				<stop offset="0%" stopColor={ props.color1 } />
				<stop offset="100%" stopColor={ props.color2 } />
			</linearGradient>
			<linearGradient id="gradient-horizontal-invert">
				<stop offset="0%" stopColor={ props.color2 } />
				<stop offset="100%" stopColor={ props.color1 } />
			</linearGradient>
		</svg>
	);
	
	return (
		<div id="ColorScheme">
			{ gradientMask }
			<style dangerouslySetInnerHTML={ styleTag } />
		</div>
	)
}


export default colorScheme;



// WEBPACK FOOTER //
// ./src/components/ColorScheme/ColorScheme.js